import { DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { EBedroomsCount } from '../../../../json_query';
import { changeBedroomsCount } from '../../../state/advanced/bedrooms_min_count';
import { InlineBlock, Row } from '../markup';

export interface IBedroomsCountProps {
  bedroomsCount: EBedroomsCount;
  onBedroomsCountChanged(value: EBedroomsCount): void;
}

export const bedroomsCount: React.StatelessComponent<IBedroomsCountProps> = props => (
  <Row title="Спален">
    <InlineBlock>
      <DropdownField
        value={props.bedroomsCount}
        onValueChange={props.onBedroomsCountChanged}
        values={[
          { value: EBedroomsCount.Any, label: 'Неважно' },
          { value: EBedroomsCount.One, label: '1' },
          { value: EBedroomsCount.Two, label: '2' },
          { value: EBedroomsCount.Three, label: '3' },
          { value: EBedroomsCount.Four, label: '4' },
          { value: EBedroomsCount.Five, label: '5' },
          { value: EBedroomsCount.Six, label: '6' },
          { value: EBedroomsCount.Seven, label: '7' },
        ]}
      />
    </InlineBlock>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    bedroomsCount:
      (state.filters.jsonQuery.bedroom_total && state.filters.jsonQuery.bedroom_total.value.gte) || EBedroomsCount.Any,
  }),
  (dispatch: Dispatch) => ({
    onBedroomsCountChanged: (value: EBedroomsCount) => {
      dispatch(changeBedroomsCount(value));
    },
  }),
)(bedroomsCount);
